// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Checkbox_shadow__2J529","checkbox":"Checkbox_checkbox__3XNad"};